import useComputed from '@/hooks/use-computed'
import api from '@/services/api/sys.js'
import { immerable } from "immer"
import { useState } from 'react'

class Sys {

	[immerable] = true

	constructor(params) {

		this.id = params.id
		this.name = params.name
		this.endPointUrl = params.endPointUrl
		this.systemConfig = params.systemConfig
		this.organizationId = params.organizationId
		this.websiteUrl = params.websiteUrl
		this.images = params.images
		this.description = params.description
		this.dataAvailability = params.dataAvailability
		this.organisation = params.organisation
		this.systemName= params.systemName

		this.$selected = false
	}
}

const useSystem = (sysId) => {

	const [items, setItems] = useComputed([])

	const [meta, setMeta] = useState(null)

	const [currentItem, setCurrentItem] = useState(null)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState()

	async function fetch(parameter) {
		setLoading(true)

		const params = parameter ? parameter : "";

		const [error, data] = await api.index({
			params
		})

		setLoading(false)

		if (error) {
			return setError(error)
		}

		const { meta } = data

		if (!Array.isArray(data.items)) {
			return setError('Sys is not an array')
		}

		const serializedData = data.items.map(entry => serialize(entry))
		const newItems = serializedData.map(params => new Sys(params))
		setMeta(meta)
		return setItems(newItems)
	}

	async function fetchByOrgId(parameter) {
		setLoading(true)

		const params = parameter ? parameter : "";

		const [error, data] = await api.index({
			params
		})

		setLoading(false)

		if (error) {
			return setError(error)
		}

		if (!Array.isArray(data)) {
			return setError('Sys is not an array')
		}
		return setItems(data)
	}

	async function find(parameter) {
		setLoading(true)

		const params = parameter ? parameter : "";

		const [error, data] = await api.index({
			params
		})

		setLoading(false)

		if (error) {
			return setError(error)
		}

		if (!Array.isArray(data)) {
			return setError('Sys is not an array')
		}

		const serializedData = data.map(entry => serialize(entry))
		const newItems = serializedData.map(params => new Sys(params))

		return newItems
	}

	async function getSysPitstops(parameter) {
		setLoading(true)

		const params = parameter ? parameter : "";

		const [error, data] = await api.getPitstops({
			params
		})

		setLoading(false)

		if (error) {
			return setError(error)
		}

		if (!Array.isArray(data)) {
			return setError('Sys is not an array')
		}
		return setItems(data)
	}


	function serialize(entry) {
		return {
			id: entry.systemId,
			name: entry.name,
			endPointUrl: entry.endPointUrl,
			systemConfig: entry.systemConfig,
			organizationId: entry.orgId,
			websiteUrl: entry.websiteUrl,
			images: entry.images,
			description: entry.desc,
			dataAvailability: entry.dataAvailability,
			organisation: entry.org,
			systemName: entry.systemName
		}
	}

	function view(id) {
		const newCurrentItem = items.find(item => item.id === id)
		setCurrentItem(newCurrentItem)
	}

	return {
		error,
		fetch,
		fetchByOrgId,
		getSysPitstops,
		items,
		currentItem,
		setCurrentItem,
		loading,
		setItems,
		view,
		find,
		meta
	}

}

export default useSystem;
